module.exports = __webpack_public_path__ + "static/media/OGG-web-types-2c.6f69e3e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-web-types-2c.jpg
// module id = 630
// module chunks = 0